import { render } from "./Playground.vue?vue&type=template&id=54de1f39&scoped=true"
import script from "./Playground.vue?vue&type=script&lang=js"
export * from "./Playground.vue?vue&type=script&lang=js"

import "./Playground.vue?vue&type=style&index=0&id=54de1f39&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54de1f39"]])

export default __exports__